class EventBus {
	events = []

	on(events, callback) {
		events.forEach(event => {
			if (!this.events[event]) {
				this.events[event] = []
			}
			this.events[event].push(callback)
		})
	}

	off(events, callback) {
		events.forEach(event => {
			if (!this.events[event]) return
			this.events[event] = this.events[event].filter(
				cb => cb !== callback
			)
		})
	}

	emit(event, payload) {
		if (!this.events[event]) return
		payload = { ...payload, eventType: event }
		this.events[event].forEach(cb => cb(payload))
	}
}

export const EventBusInstance = new EventBus()
